import {toast as sonnerToast} from "sonner";

import {TOAST_CONFIG} from "../utils/constants";

type Toast = Parameters<typeof sonnerToast>;

function toast(message: Toast[0], options: Toast[1] = {}) {
  sonnerToast(message, {...TOAST_CONFIG, ...options});
}

toast.success = (message: Toast[0], options: Toast[1] = {}) => {
  sonnerToast.success(message, {...TOAST_CONFIG, ...options});
};
toast.error = (message: Toast[0], options: Toast[1] = {}) => {
  sonnerToast.error(message, {...TOAST_CONFIG, ...options});
};
toast.info = (message: Toast[0], options: Toast[1] = {}) => {
  sonnerToast.info(message, {...TOAST_CONFIG, ...options});
};
toast.warning = (message: Toast[0], options: Toast[1] = {}) => {
  sonnerToast.warning(message, {...TOAST_CONFIG, ...options});
};

export default function useToast() {
  return toast;
}

export {toast};
